import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ProductSlider } from "@/components/ProductSlider";

export const RECENT_KEY = "vira_recently_viewed";

export const RecentlyViewed = () => {
  const [products, setProducts] = useState([]);
  const [brands, setBrands] = useState([]);

  useEffect(() => {
    let ids = [];
    try {
      ids = JSON.parse(localStorage.getItem(RECENT_KEY)) || [];
    } catch {}
    if (!ids.length) return;
    api.get("/products").then((r) => {
      const byId = new Map(r.data.map((p) => [p.id, p]));
      setProducts(ids.map((id) => byId.get(id)).filter(Boolean).slice(0, 12));
    }).catch(() => {});
    api.get("/brands").then((r) => setBrands(r.data)).catch(() => {});
  }, []);

  return (
    <ProductSlider
      eyebrow="Pick Up Where You Left Off"
      title={<>Recently <em className="text-gold">Viewed</em></>}
      products={products}
      brandName={(slug) => brands.find((b) => b.slug === slug)?.name || slug}
      testId="recently-viewed"
    />
  );
};
